import { IOEventIn } from '@src/lib/types';

import _cannotDraw from './_cannotDraw';
import _cardsUpdated from './_cardsUpdated';
import _chat from './_chat';
import _chooseColor from './_chooseColor';
import _createdGameId from './_createdGameId';
import _drawFour from './_drawFour';
import _drawTwo from './_drawTwo';
import _errorInRequest from './_errorInRequest';
import _gameStarted from './_gameStarted';
import _gameEnd from './_gameEnd';
import _gameUpdated from './_gameUpdated';
import _joinedGame from './_joinedGame';
import _kick from './_kick';
import _playerDisconnected from './_playerDisconnected';
import _playerIndexChanged from './_playerIndexChanged';
import _reverseTurn from './_reverseTurn';
import _skipTurn from './_skipTurn';
import _uno from './_uno';
import _wrongMove from './_wrongMove';
import _wrongTurn from './_wrongTurn';
import _gameDetails from './_gameDetails';
import _connected from './_connected';
import _playerDrawingCard from './_playerDrawingCard';
import _creatingOnchainGame from './_creatingOnchainGame';
import _globalUpdate from './_globalUpdate';
import _playerMetadata from './_playerMetadata';
import _watchingGame from './_watchingGame';
import _tournamentDetails from './_tournamentDetails';

const events: IOEventIn[] = [
  {
    event: 'cannotDraw',
    getCallback: _cannotDraw,
  },
  {
    event: 'cardsUpdated',
    getCallback: _cardsUpdated,
  },
  {
    event: 'chat',
    getCallback: _chat,
  },
  {
    event: 'chooseColor',
    getCallback: _chooseColor,
  },
  {
    event: 'createdGameId',
    getCallback: _createdGameId,
  },
  {
    event: 'drawFour',
    getCallback: _drawFour,
  },
  {
    event: 'drawTwo',
    getCallback: _drawTwo,
  },
  {
    event: 'errorInRequest',
    getCallback: _errorInRequest,
  },
  {
    event: 'gameStarted',
    getCallback: _gameStarted,
  },
  {
    event: 'gameEnd',
    getCallback: _gameEnd,
  },
  {
    event: 'gameUpdated',
    getCallback: _gameUpdated,
  },
  {
    event: 'globalUpdate',
    getCallback: _globalUpdate,
  },
  {
    event: 'joinedGame',
    getCallback: _joinedGame,
  },
  {
    event: 'kick',
    getCallback: _kick,
  },
  {
    event: 'playerDisconnected',
    getCallback: _playerDisconnected,
  },
  {
    event: 'playerIndexChanged',
    getCallback: _playerIndexChanged,
  },
  {
    event: 'reverseTurn',
    getCallback: _reverseTurn,
  },
  {
    event: 'skipTurn',
    getCallback: _skipTurn,
  },
  {
    event: 'uno',
    getCallback: _uno,
  },
  {
    event: 'wrongMove',
    getCallback: _wrongMove,
  },
  {
    event: 'wrongTurn',
    getCallback: _wrongTurn,
  },
  {
    event: 'gameDetails',
    getCallback: _gameDetails,
  },
  {
    event: 'connected',
    getCallback: _connected,
  },
  {
    event: 'playerDrawingCard',
    getCallback: _playerDrawingCard,
  },
  {
    event: 'creatingOnchainGame',
    getCallback: _creatingOnchainGame,
  },
  {
    event: 'playerMetadata',
    getCallback: _playerMetadata,
  },
  {
    event: 'watchingGame',
    getCallback: _watchingGame,
  },
  {
    event: 'tournamentDetails',
    getCallback: _tournamentDetails,
  },
];

export default events;
